module.exports = __webpack_public_path__ + "media/images/talent/case1-badge-387ce0ed5f71ad35d8bad9aadaa290a1.png";